import React, { Component } from "react";
import SubscriptionDrawer from "../../Components/Drawer/SubscriptionDrawer";
import SubscriptionPortal from "../../Components/Subscription/SubscriptionPortal";

export class SubscriptionPortalPage extends Component {
    render() {
        return (
            <>
                <SubscriptionDrawer
                    organizations={this.props.organizations}
                    orgName={this.props.match.org_id}
                    selected={"Subscription Type"}
                >
                    <SubscriptionPortal />
                </SubscriptionDrawer>
            </>
        );
    }
}
